module.exports = __webpack_public_path__ + "static/media/ic_close_grey.7af3cacf.svg";